<template>
  <div class="actionBtn">
    <div class="actionBox_Add">
      <div class="rj-page-card">
        <div class="rj-page-card__content">
          <el-button type="primary" :loading="loading" @click="GetPaymentRatioCheck()">
            发布合同
          </el-button>
          <el-button v-if="contractType !== '销售借用下单' && !asInterDirect" type="default" :loading="loading" @click="dismissedSuggestions()">
            驳回到代理商
          </el-button>
          <el-button type="default" :loading="loading" @click="submit(1)">
            保存草稿
          </el-button>
          <el-button v-if="isHardWare && contractType !== '服务订单'" type="default" :loading="loading" @click="hardWare()">
            软件拆分
          </el-button>
        </div>
      </div>
      <el-dialog
        title="友情提示"
        class="dialog"
        :visible.sync="dialogVisible"
        width="450px"
        top="15px"
        @close="close"
      >
        <span class="spanBox">
          <span class="dialogSpan">
            此单应预付款金额/比例：{{ this.baseData.advanceCharge }}元
            <span v-if="this.baseData.isBorrowProduct" style="color:red">
              <span>(含冲销{{ this.baseData.isBorrowProductsAmount }}元)</span>
            </span>
            /{{ this.baseData.prepaymentRatioNum }}%,

          </span><br>
          <span class="dialogSpan">
            目前已分配金额/比例：{{ this.baseData.assignAmount }}元/{{ this.baseData.assignAmountRatioNum }}%。
          </span><br>
          <span class="dialogSpan">
            已分配金额/比例小于应付款金额/比例，
          </span><br>
          <span class="dialogSpan">
            点击确定发布继续走合同流程，
          </span><br>
          <span class="dialogSpan">
            点击取消发布则取消合同的发布。
          </span><br>
        </span>

        <div style="width: 100%;display: flex;justify-content: space-around; margin-top:20px;align-items: center;">
          <el-button type="default" :loading="loading" @click="cancel">
            取消发布
          </el-button>
          <el-button type="primary" :loading="loading" @click="submit(0)">
            确定发布
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script type="es6">
import { paymentRatioCheck } from '@/API';
export default {
  data () {
    return {
      loading: false,
      dialogVisible: false,
      baseData: {}
    };
  },
  props: {
    isHardWare: {
      type: [Boolean, String],
      default: false
    },
    contractType: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    // 是否直签 false(非直签) true(直签)
    asInterDirect: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    cancel () {
      this.close();
    },
    close () {
      this.dialogVisible = false;
    },
    // 调用 预算比例接口
    GetPaymentRatioCheck () {
      this.loading = true;
      let contractId = {
        contractId: this.id
      };
      paymentRatioCheck(contractId).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          if (!json.data.passed) {
            this.dialogVisible = true;
            this.baseData = json.data;
          } else {
            this.submit(0);
          }
        }
      }).catch((res) => {
        this.loading = false;
      });
    },
    submit (val) {
      if (!val) {
        this.loading = true;
        this.$parent.submit(val, (val) => {
          this.loading = false;
        });
      } else {
        this.$parent.submit(val, () => {
          this.loading = false;
        });
      }
    },
    Reject () {
      this.loading = false;
      this.$parent.Reject(() => {
        this.loading = false;
      });
    },
    dismissedSuggestions () {
      this.$parent.suggestionInfo(() => {

      });
    },
    hardWare () {
      this.$parent.toHardWare(() => {

      });
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss">
  .actionBtn{
    .actionBox_Add{
        position: fixed;
        bottom: 0;
        width: 100%;
        z-index: 1000;

        .rj-page-card{
          background: rgba(64,158,255,0.2);
          padding: 0;
        }
    .dialog{
      .spanBox{
        display: inline-block;
        width: 100%;
          text-align: center;
          letter-spacing: 3px;
            .dialogSpan{
              display: inline-block;
              height:20px;
              line-height: 20px;
            }
      }
    }
}
  }
</style>
